import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import fetchPayrollService from './usePayrollService.request';
import { PayrollServiceData } from './usePayrollService.interface';

const usePayrollService = (options?: Omit<UseQueryOptions<PayrollServiceData>, 'queryKey' | 'queryFn'>) => {
    return useQuery<PayrollServiceData>({
        queryKey: ['payroll', 'usePayrollService'],
        queryFn: fetchPayrollService,
        retry: false,
        refetchOnWindowFocus: false,
        staleTime: Infinity,
        ...options,
    });
};

export default usePayrollService;
